import { ProductNameEnum } from '../models';

const featureCodesMap = {
  [ProductNameEnum.AscendQuest]: ProductNameEnum.AscendQuest,
  [ProductNameEnum.AscendArchives]: ProductNameEnum.AscendArchives,
  [ProductNameEnum.AscendVerifications]: ProductNameEnum.AscendVerifications,
  [ProductNameEnum.AscendUSAA]: ProductNameEnum.AscendUSAA,
  Admin: 'Admin',
  Notifications: 'Notifications',
  UserAccount: 'UserAccount',
} as const;

export type FeatureCodeType = keyof typeof featureCodesMap;

export const FeatureCodes = featureCodesMap;

export const FeatureShortCodes: Record<string, string> = {
  [ProductNameEnum.AscendQuest]: 'QST',
  [ProductNameEnum.AscendArchives]: 'ARC',
  [ProductNameEnum.AscendVerifications]: 'VER',
  [ProductNameEnum.AscendUSAA]: 'USAA',
};

export const getShortCodeForFeature = (featureCode: string): string | null => {
  return FeatureShortCodes[featureCode] || null;
};

export const FeatureRolePrefixes: Record<string, string> = {
  [ProductNameEnum.AscendQuest]: 'Quest',
  [ProductNameEnum.AscendArchives]: 'Archives',
  [ProductNameEnum.AscendVerifications]: 'Verifications',
  [ProductNameEnum.AscendUSAA]: 'USAA',
};

export const getRolePrefixForFeature = (featureCode: string): string | null => {
  return FeatureRolePrefixes[featureCode] || null;
};

export const getShortNameForProductToLower = (productName: string) => {
  return FeatureRolePrefixes[productName]?.toLowerCase();
};

export const getShortNameForProduct = (productName: string) => {
  return FeatureRolePrefixes[productName];
};
